import { dialogDefault, DIALOG_CHANGECATEGORY } from "../consts";

const mydialog = {...dialogDefault, categories: ''}


export const changeCategoryDialog = ({ open = false, id = 0, code=0, name = '', categories = '' }) => ({
    type: DIALOG_CHANGECATEGORY,
    payload : { open, id, code, name, categories }
});

export default function changeCategoryDialogReducer(state = mydialog, { type, payload }) {

    const actions = {
        [DIALOG_CHANGECATEGORY] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

